import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    academic_period: '',
  },
}

export const milestonesUI = createSlice({
  name: 'milestonesUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setAcademicPeriod: (state, { payload }) => {
      state.tableFilters.academic_period = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setAcademicPeriod,
  trackActiveFilters,
  clearAllFilters,
} = milestonesUI.actions

export default milestonesUI.reducer
